import type { NavigationGuardWithThis } from 'vue-router'
import { useAuthStore } from '@/stores/auth.store'
import { usePermissionsStore } from '@/stores/permissions.store'

export const permissionGuard: NavigationGuardWithThis<undefined> = (to) => {
  const auth = useAuthStore()
  if (!auth.isAuthenticated) return true

  const requiredPermissions = to.meta.permissions ?? []
  const requiredRoles = to.meta.roles ?? []

  if (requiredPermissions.length === 0 && requiredRoles.length === 0) {
    return true
  }

  const permissions = usePermissionsStore()
  const userRole = auth.user?.role

  const hasPermission =
    requiredPermissions.length === 0 ||
    requiredPermissions.some((p) => permissions.permissions.has(p))

  const hasRole =
    requiredRoles.length === 0 ||
    (userRole !== undefined && requiredRoles.includes(userRole))

  if (hasPermission && hasRole) return true
  return { name: 'forbidden' }
}
